module.exports = __webpack_public_path__ + "img/azud.31726b6b.png";